var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9076",
    "data-name": "Group 9076",
    transform: "translate(-2626 -1597)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_11025",
    "data-name": "Path 11025",
    transform: "translate(2626 1597)",
    fill: "#fff",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.5 12.5 L 0.5 12.5 L 0.5 0.5 L 12.5 0.5 L 12.5 12.5 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1 1 L 1 12 L 12 12 L 12 1 L 1 1 M 0 0 L 13 0 L 13 13 L 0 13 L 0 0 Z",
    stroke: "none",
    fill: "#707070"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_11024",
    "data-name": "Path 11024",
    d: "M8372.21-1415.456a.519.519,0,0,1-.52-.519.519.519,0,0,1,.52-.517h3.71a2.736,2.736,0,0,0,2.732-2.732,2.736,2.736,0,0,0-2.732-2.732h-7.262l1.878,2.149a.519.519,0,0,1-.048.732.519.519,0,0,1-.341.128.519.519,0,0,1-.392-.179l-2.629-3.007a.567.567,0,0,1-.037-.049l0,0-.008-.012-.007-.011a.007.007,0,0,1,0,0,.513.513,0,0,1-.071-.261.52.52,0,0,1,.138-.352l2.619-3a.52.52,0,0,1,.732-.048.519.519,0,0,1,.048.732l-1.876,2.147h7.26a3.773,3.773,0,0,1,3.769,3.769,3.773,3.773,0,0,1-3.769,3.769Z",
    transform: "translate(-5740.999 3024)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.3877518b.svg";
export { ForwardRef as ReactComponent };